import { billingClaimStatusOptions } from "components/lab/billingCharge/consts";
import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import ReactSelect from 'react-select'

interface SelectClaimStatusModalProps {
  show: boolean
  onClose: () => void
  onSubmit: (claimStatus: string) => void
  submitLabel?: string
}

export const SelectClaimStatusModal = ({
  show,
  onClose,
  onSubmit,
  submitLabel = 'Submit to Optum',
}: SelectClaimStatusModalProps) => {
  const [selectedStatus, setSelectedStatus] = useState<{ value: string; label: string } | null>({ value: '2', label: 'Billed To Prim plan (EDI)' })

  const handleSubmit = () => {
    if (selectedStatus) {
      onSubmit(selectedStatus.value)
    }
  }

  return (
    <Modal centered show={show} onHide={onClose}>
      <Modal.Header>
        <Modal.Title>Select Claim Status</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label className="text-gray mb-2" htmlFor="claimStatus">
            Claim Status
          </label>
          <ReactSelect
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 10000 }) }}
            className="basic-single w-100"
            classNamePrefix="select"
            placeholder="Select Claim Status"
            name="claimStatus"
            onChange={(item) => setSelectedStatus(item)}
            options={billingClaimStatusOptions.map((x) => ({ value: x.key, label: x.value }))}
            value={selectedStatus}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button autoFocus variant="primary" onClick={handleSubmit} disabled={!selectedStatus}>
          {submitLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
